import { savedSearchAlertId } from './saved-search-alert-id';
import { searchIdentityKey } from './search-history-policy';
import type { ServerSavedSearch } from './server-saved-searches';

/**
 * The account item that represents a given search URL, if any. Exact id match first (the
 * common case for a search saved from this very URL); otherwise the item whose URL is the same
 * search by `searchIdentityKey` (same query and refinements, ignoring sort, page, map view,
 * case, param order). Among identity matches an alert-enabled item wins, so an SRP the user
 * reaches through a different link than the one they saved still reads as "alerts on", and
 * enabling from that SRP updates the existing item instead of creating a second one.
 */
export function findSavedSearchForUrl(
  items: Record<string, ServerSavedSearch>,
  url: string
): ServerSavedSearch | undefined {
  if (!url) return undefined;
  const exact = items[savedSearchAlertId(url)];
  if (exact) return exact;
  const key = searchIdentityKey(url);
  let fallback: ServerSavedSearch | undefined;
  for (const item of Object.values(items)) {
    if (searchIdentityKey(item.url) !== key) continue;
    if (item.alertEnabled) return item;
    fallback ??= item;
  }
  return fallback;
}
